// Auditoria do Pedido (PO1-3240 / PO1-3243): regras puras da tela — rótulos,
// seleção de faturas para o lote e textos. Sem React, para testar isolado.

export const PERMISSAO_VER = "hub.fatura.conferencia.visualizar";
export const PERMISSAO_DECIDIR = "hub.fatura.conferencia.conciliar";
export const ROTA_AUDITORIA_PEDIDO = "/app/flow/operacao/auditoria-pedido";
export const ROTA_AUDITORIA_FATURAS = "/app/flow/operacao/auditoria-faturas";

export const urlAuditoriaPedido = (pedido) =>
  `${ROTA_AUDITORIA_PEDIDO}?pedido=${encodeURIComponent(String(pedido || "").trim())}`;
export const urlAuditoriaFaturas = (pedido) =>
  `${ROTA_AUDITORIA_FATURAS}?pedido=${encodeURIComponent(String(pedido || "").trim())}`;

// Admin Everlog tem bypass, como no menu (filterMenuForUser).
export function temPermissao(user, permissao) {
  if (!user) return false;
  if (user.setor === "admin") return true;
  return Array.isArray(user.permissions) && user.permissions.includes(permissao);
}

export const pedidoDaUrl = (search) => {
  const valor = new URLSearchParams(search || "").get("pedido");
  return valor ? valor.trim() : "";
};

export const ROTULO_INDICIO = {
  VALOR_FECHADO_COM_ICMS: "Valor fechado com ICMS",
  NENHUM_VEICULO_EXPLICA: "Nenhum veículo explica o valor",
  ACIMA_DAS_OFERTAS: "Acima de todas as ofertas",
  MESMO_VALOR_EM_TODOS: "Mesmo valor com carga diferente",
  NF_DIFERENTE_DA_COTADA: "Valor das notas diferente do cotado",
};

export const rotuloIndicio = (codigo) => ROTULO_INDICIO[codigo] || codigo;

export const MOTIVO_INELEGIVEL = {
  // Motivo da fatura (não de um documento): neutro, vale para CT-e e NFse (PO1-3299).
  ctes_de_outros_pedidos: "Tem documento (CT-e/NFse) de outro pedido: decida na Auditoria de Faturas",
  estrutural: "Erro estrutural: não pode ser aprovada",
  situacao: "Situação fora de decisão",
};

export function textoInelegivel(fatura) {
  if (!fatura || fatura.elegivelLote) return null;
  const base = MOTIVO_INELEGIVEL[fatura.motivoInelegivel] || "Fora de decisão";
  if (fatura.motivoInelegivel === "situacao" && fatura.situacao && fatura.situacao.nome) {
    return `${base} (${fatura.situacao.nome})`;
  }
  return base;
}

// Só faturas elegíveis entram na seleção; ids desconhecidos são descartados.
export function alternarSelecao(selecionadas, fatura) {
  if (!fatura || !fatura.elegivelLote) return selecionadas;
  const proxima = new Set(selecionadas);
  if (proxima.has(fatura.id)) proxima.delete(fatura.id);
  else proxima.add(fatura.id);
  return proxima;
}

export function selecionarTodasElegiveis(faturas) {
  return new Set((faturas || []).filter((f) => f.elegivelLote).map((f) => f.id));
}

export function faturasSelecionadas(faturas, selecionadas) {
  return (faturas || [])
    .filter((f) => f.elegivelLote && selecionadas.has(f.id))
    .map((f) => ({ id: f.id, numFaturaExterna: f.numero, situacaoCodigo: f.situacao && f.situacao.codigo }));
}

// Observação pré-preenchida do lote: cita o pedido (rastro na fatura).
export function observacaoPadrao(acao, pedido) {
  if (acao === "DEVOLVER") {
    return `Auditoria do pedido ${pedido}: o valor cobrado não confere com a cotação e com a tabela de frete. Pedimos a correção da cobrança.`;
  }
  return `Auditoria do pedido ${pedido}: `;
}

// Veículo cujo valor esperado mais se aproxima do cobrado (indício NENHUM_VEICULO_EXPLICA).
export function veiculoMaisProximo(item) {
  if (!item || !Array.isArray(item.veiculos) || !item.veiculos.length) return null;
  return item.veiculos.reduce((melhor, v) =>
    Math.abs(item.cobrado - v.esperado) < Math.abs(item.cobrado - melhor.esperado) ? v : melhor
  );
}

export const TOM_DIFERENCA = (dif) => (dif > 0.009 ? "danger" : dif < -0.009 ? "success" : "neutral");

export const nomeArquivoPdf = (pedido) =>
  `auditoria-pedido-${String(pedido || "").replace(/[^A-Za-z0-9_-]+/g, "_")}.pdf`;
